import React, { createContext, useContext, useEffect, useState } from 'react';
import { io, Socket } from 'socket.io-client';
import { config } from '../config/environment';

interface SocketContextType {
  socket: Socket | null;
  isConnected: boolean;
  monitoringData: any;
  systemData: any;
}

const SocketContext = createContext<SocketContextType>({
  socket: null,
  isConnected: false,
  monitoringData: null,
  systemData: null,
});

export const useSocket = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }
  return context;
};

interface SocketProviderProps {
  children: React.ReactNode;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children }) => {
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isConnected, setIsConnected] = useState(false);
  const [monitoringData, setMonitoringData] = useState(null);
  const [systemData, setSystemData] = useState(null);

  useEffect(() => {
    const newSocket = io(config.SOCKET_URL);
    
    newSocket.on('connect', () => {
      console.log('Socket bağlantısı kuruldu');
      setIsConnected(true);
    });

    newSocket.on('disconnect', () => {
      console.log('Socket bağlantısı kesildi');
      setIsConnected(false);
    });

    newSocket.on('monitoring-data', (data) => {
      setMonitoringData(data);
    });

    newSocket.on('system-data', (data) => {
      setSystemData(data);
    });

    newSocket.on('error', (error) => {
      console.error('Socket hatası:', error);
    });

    setSocket(newSocket);

    return () => {
      newSocket.close();
    };
  }, []);

  return (
    <SocketContext.Provider value={{
      socket,
      isConnected,
      monitoringData,
      systemData
    }}>
      {children}
    </SocketContext.Provider>
  );
};
